import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { UserManager } from '../../services/managers/user.manager';

import { Account } from '../../model/account';
import { AccountHelper } from '../../lib/accountHelper';
import { RodeoManagePage } from './rodeo/rodeo-manage';
import { OrganizationPage } from './organization/organization';
import { AlertController, NavController } from 'ionic-angular';
import { LocalStorageService } from '../../services/local-storage';
import { DataService } from '../../services/data';
import { LoginPage } from '../../pages/login';
import { AlertMessager } from '../../lib/alertMessager';
import { ENV } from '../../environments/environment';
import { PrintService } from '../../services/print-service';
import { MonitoringService } from '../../services/AppInsights/monitoring-service';

@Component({
    selector: 'page-staff',
    templateUrl: 'staff.html'
})
export class StaffPage implements OnInit, OnDestroy {
    @ViewChild('rodeo') rodeo: RodeoManagePage;
    @ViewChild('organization') organization: OrganizationPage;

    subscriptions: Subscription[] = [];
    accountHelper: AccountHelper = AccountHelper.instance();

    selectedMode: string = 'rodeos';
    appVersion: any = ENV.appVersion;
    account: Account;
    popoverActive: boolean = false;
    printing = false;
    
    constructor(private printService: PrintService, private userManager: UserManager, private alertController: AlertController, private localStorage: LocalStorageService, 
        private dataService: DataService, private navController: NavController, private alertMessager: AlertMessager, private monitoringService: MonitoringService) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.printService.printing.subscribe(printing => this.printing = printing)
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }
    ionViewDidLoad() {
        console.log("rodeo: ", this.rodeo);
        console.log("organization: ", this.organization);
        
        this.showManageRodeos();
    }

    ionViewDidEnter() {
        this.subscriptions.push(this.userManager.account.subscribe(account => {
            this.account = account;
        }));
    }

    ionViewWillLeave() {
        for (let i = 0; i < this.subscriptions.length; i++) {
            let subscription = this.subscriptions[i];

            if (!subscription.closed)
                subscription.unsubscribe();
        }
    }

    logout() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Logout',
            message: 'Do you want to logout?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                        console.log('No clicked');
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        this.dataService.logout()
                            .then(data => {
                                AccountHelper.instance().clearToken();
                                this.localStorage.purge();
                                this.navController.setRoot(LoginPage);
                                this.monitoringService.clearUserId();
                            }, error => this.alertMessager.showError('Logout Error', error));
                    }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        });
    }

    showManageRodeos() {
        this.selectedMode = 'rodeos';
        this.rodeo.load();
    }

    showManageOrganizations() {
        this.selectedMode = 'organizations';
        this.organization.load();
    }

    showManagePhoto() {
        this.selectedMode = 'photo';
    }

    showManageVideo() {
        this.selectedMode = 'video';
    }

    showEquiStat() {
        this.selectedMode = 'equistat';
    }

    showAdmin() {
        this.selectedMode = 'admin';
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/staff.ts